import * as React from 'react';

var _path, _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#275AE6",
    stroke: "#fff",
    strokeWidth: 2,
    d: "M29 15c0 7.732-6.268 14-14 14S1 22.732 1 15 7.268 1 15 1s14 6.268 14 14z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 14,
    y: 9,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    x: 14,
    y: 13,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    rx: 1
  })));
}

export { SvgInfo as ReactComponent };
//# sourceMappingURL=Info.svg.js.map
